import AlternativeBox from 'BoxAlternatives/Alternative';
import Helthjem from 'BoxAlternatives/Helthjem';
import type { Sections } from 'types';

type Props = {
    finnkode: string;
    sections: Sections;
};

const App = (props: Props) => {
    const {
        finnkode,
        sections: { helthjem, alternatives },
    } = props;
    if (helthjem) return <Helthjem finnkode={finnkode} helthjem={helthjem} />;

    if (alternatives) return <AlternativeBox alternative={alternatives} />;
    return null;
};

export default App;
